module.exports = __webpack_public_path__ + "static/media/the-promised-land.2532557a.jpg";